import { Component, Input } from '@angular/core'
import { ResponsibleForSign } from 'src/app/models/Reports'

@Component({
	selector: 'app-footer-report',
	templateUrl: './footer-report.component.html'
})
export class FooterComponent {
		@Input() public qrCode: string = ''
	@Input() public assign: boolean = false
	@Input() public isAppraisalReport: boolean = false
	@Input() public isNotification: boolean = false
	@Input() public responsibleForSign: ResponsibleForSign = new ResponsibleForSign()
}
